// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"392":"31455ad4","400":"f713590e"}[chunkId] + ".chunk.js";
};